import styled, { css, keyframes } from "styled-components";
import { PlainTextStyle } from "../../styled";

export const SectionMethodology = styled.div`
    padding-bottom: 150px;
`;

export const MethodContainer = styled.div`
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
`;

export const MethodTitle = styled.h2`
    font-weight: 700;
    font-size: 79px;
    margin-bottom: 74px;
    line-height: 1;
    position: relative;
    z-index: 1;
    @media (max-width: 1199px) {
        font-size: 60px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        margin-bottom: 34px;
    }
`;

export const MethodItems = styled.div`
    display: flex;
    justify-content: space-between;
    @media (max-width: 1199px) {
        flex-direction: column;
        gap: 40px;
    }
`;

export const MethodBlock1 = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    grid-gap: 20px;
    width: 40%;
    @media (max-width: 1199px) {
        grid-template-columns: 1fr;
        width: 100%;
    }
`;
1;

export const MethodBlock2 = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    grid-gap: 20px;
    width: 40%;
    @media (max-width: 1199px) {
        width: 100%;
    }
`;

export const MethodBlockText = styled.div`
    ${PlainTextStyle}
    width: 415px;
    line-height: 1.4;
    z-index: 1;
    @media (max-width: 1199px) {
        font-size: 20px;
        width: 100%;
    }
`;

export const MethodArrows = styled.div`
    margin-left: -50px;
    display: flex;
    align-items: center;
    justify-content: start;
    @media (max-width: 1199px) {
        display: none;
    }
`;

const arrow = css`
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 70px 0 70px 70px;
    border-color: transparent transparent transparent #edd2b1;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
`;

const arrowAnimation = keyframes`
    0% {
        opacity: 0.2;
    }
    100% {
        opacity: 1;
    }
`;

export const MethodBlockArrow1 = styled.div`
    ${arrow}
    animation-name: ${arrowAnimation};
    animation-delay: 0.5s;
    animation-duration: 1s;
`;

export const MethodBlockArrow2 = styled.div`
    ${arrow}
    animation-name: ${arrowAnimation};
    animation-delay: 1s;
    animation-duration: 1.5s;
`;

export const MethodBlockArrow3 = styled.div`
    ${arrow}
    animation-name: ${arrowAnimation};
    animation-delay: 1.5s;
    animation-duration: 2s;
`;

export const MethodBlockImage1 = styled.img`
    flex-shrink: 0;
    width: 70px;
    height: 60px;
`;

export const MethodBlockImage2 = styled.img`
    flex-shrink: 0;
    width: 78px;
    height: 60px;
`;

export const MethodBlockImage3 = styled.img`
    flex-shrink: 0;
    width: 137px;
    height: 60px;
`;

export const MethodBlockImage4 = styled.img`
    flex-shrink: 0;
    width: 144px;
    height: 60px;
`;

export const MethodBlockImage5 = styled.img`
    flex-shrink: 0;
    width: 111px;
    height: 60px;
`;

export const MethodBlockImage6 = styled.img`
    flex-shrink: 0;
    width: 395px;
    height: 60px;
`;
